import { RouterReducerState, getRouterSelectors } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRouter from './router.reducer';

// https://ngrx.io/guide/router-store/selectors

export const selectRouter = createFeatureSelector<RouterReducerState>(
  fromRouter.routerFeatureKey,
);

export const {
  selectCurrentRoute, // select the current route
  selectFragment, // select the current route fragment
  selectQueryParams, // select the current route query params
  selectQueryParam, // factory function to select a query param
  selectRouteParams, // select the current route params
  selectRouteParam, // factory function to select a route param
  selectRouteData, // select the current route data
  selectRouteDataParam, // factory function to select a route data param
  selectUrl, // select the current url
  selectTitle, // select the title if available
} = getRouterSelectors(selectRouter);

export const selectParentRouteTitle = createSelector(
  selectCurrentRoute,
  (route) => {
    if (!route) {
      return null;
    }
    const parent = route.parent;
    if (!parent) {
      return null;
    }
    return parent.title;
  },
);
